// RTK have it's own actions. These action creaters are specifically for sagas
import { createAction } from '@reduxjs/toolkit';
import { Task as TaskApi } from 'api/tasks';
import { Task } from 'data/tasks';

interface GetTaskPayload {
  documentId: number;
  projectId: number;
}

interface CreateTaskPayload extends GetTaskPayload {
  taskName: string;
  resourceSectionId?: number;
  taskDescription?: string;
}

export interface CreateSectionTaskPayload extends GetTaskPayload {
  taskName: string;
  taskDescriptionPostfix?: string;
  meta: {
    resourceSectionId: number;
    documentSectionId: number;
    private: boolean;
  };
  updateLocalState?: (newSubTask: TaskApi) => void;
}

export interface UpdateTaskPayloadOptions {
  resolveCallback?: (value) => void;
}

interface UpdateTaskPayload {
  projectId: number;
  taskId: number;
  partialTask: Partial<Task>;
  options?: UpdateTaskPayloadOptions;
}

interface DocTaskIdNameMapPayload extends GetTaskPayload {
  resourceSectionName?: string;
  resourceSectionId: number;
  resourceObjects?: Task[];
  isReplaceExisting?: boolean;
}

export const getDocTasks = createAction<GetTaskPayload>(
  'documents/saga/get-tasks',
);

export const createDocTask = createAction<CreateTaskPayload>(
  'documents/saga/create-task',
);

export const createDocSectionTask = createAction<CreateSectionTaskPayload>(
  'documents/saga/create-doc-section-task',
);

export const updateDocTask = createAction<UpdateTaskPayload>(
  'documents/saga/update-task',
);

export const updateDocTaskIdNameMap = createAction<DocTaskIdNameMapPayload>(
  'documents/saga/update-task-section-id-name-map',
);
